import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_NOT_MADE,
  LOGOUT_SUCCESS,
  LOGOUT_REQUEST,
  CLEAR_ERROR,
} from "@/constants";
import { LoginNotMadeError, loginRequestTypes, LoginSuccessfulData } from "../types/auth";

export function loginRequest(type: loginRequestTypes) {
  return {
    type: LOGIN_REQUEST,
    payload: {type}
  };
}

export function loginSuccess(data?: LoginSuccessfulData) {
  return {
    type: LOGIN_SUCCESS,
    payload: data
  };
}

export function loginFailure(errorData: LoginNotMadeError) {
  return {
    type: LOGIN_FAILURE,
    payload: errorData
  };
}

export const loginNotMade = (err?: LoginNotMadeError) => {
  return {
    type: LOGIN_NOT_MADE,
    payload: err
  }
}

export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS
  };
}

export function logoutRequest() {
  return {
    type: LOGOUT_REQUEST
  };
}

const clearError = () => {
  return {
    type: CLEAR_ERROR
  }
}

export default {
  loginRequest,
  loginSuccess,
  loginFailure,
  loginNotMade,
  logoutRequest,
  logoutSuccess,
  clearError
}
